<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

//
import { SecondaryDataInterface } from "@/types/ContentType";
import { useMainStore } from "@/store/main/index";
import Video from "@/components/regularComponents/UIComponents/Video.vue";
import { ref, onMounted } from "vue";

const props = defineProps<{
  contentData: SecondaryDataInterface;
}>();

const mainStore = useMainStore();

const noPadding = ref(false);

const getEmbedHTML = (html: string): string => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const iframe = div.querySelector("iframe");
  if (iframe) {
    iframe.src = iframe.src + "&controls=0&muted=1";
  }

  return div.innerHTML
};

onMounted(() => {
  if (props?.contentData?.conf?.conf?.includes("no-padding")) {
    noPadding.value = true;
  }
});
</script>

<template>
  <section
    v-if="mainStore?.windowWidth > 983"
    class="video-page"
    :style="{ 'padding-top': noPadding ? '0px' : undefined }"
  >
    <div class="video-page__container pos-rel">
      <div
        v-if="contentData?.data?.list[0]?.embed"
        class="video-page__embed w-full h-full pos-abs ev-none"
        v-html="getEmbedHTML(contentData?.data?.list[0]?.embed)"
      ></div>
      <Video v-else-if="contentData?.data?.list?.[0]?.video?.videoFile?.url" :contentData="contentData" />
    </div>
  </section>
</template>

<style lang="scss">
.video-page {
  padding-top: 205px;
  @include maxq(desktop-2k) {
    padding-top: 133px;
  }
  @include maxq(desktop-lg) {
    padding-top: 104px;
  }
  &__container {
    padding-top: 56.08%;
    height: 0;
  }

  &__embed {
    top: 0;
    left: 0;

    iframe {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
